// extracted by mini-css-extract-plugin
export default {"rate":"Rate_rate__hvKze"};